<template>
  <div>
    <dx-scip-sales
      :product-key="key"
      :variant-key="variantKey"
      :version-number="versionNumber"
      :contract-id="contractId"
    />
  </div>
</template>

<script>
import DxScipSales from '~/components/DX-ScipSales'

export default {
  name: 'BrokerOfferScipSales',
  components: {
    DxScipSales,
  },
  layout: 'non-sticky-nav',
  nuxtI18n: {
    paths: {
      de: '/partnerportal/antragsstrecke/',
      fr: '/portailpartenaires/formulaire-de-demande/',
    },
  },

  computed: {
    key() {
      return this.$route.query.key || ''
    },
    variantKey() {
      return this.$route.query.variantKey || ''
    },
    versionNumber() {
      return Number(this.$route.query.versionNumber) || 1
    },

    contractId() {
      return Number(this.$route.query.contractId) || null
    },
  },
}
</script>
